import { toCamelCaseObject, toSnakeCaseObject } from 'common/helpers/utils';
import { AdapterService } from 'common/types/services';

import {
  FaceLoginApiRequest,
  FaceLoginAPiResponse,
  FaceLoginRequest,
  FaceLoginResponse,
} from './authentication.type';

export class FaceLoginResponseAdapter implements AdapterService {
  static adapt = (response: FaceLoginAPiResponse) => {
    return toCamelCaseObject<FaceLoginResponse, FaceLoginAPiResponse>(response);
  };
}

export class FaceLoginRequestAdapter implements AdapterService {
  static adapt = (
    request: FaceLoginRequest['data'],
    type: FaceLoginRequest['type'],
    provider: FaceLoginRequest['provider'],
  ) => {
    return toSnakeCaseObject<FaceLoginApiRequest, FaceLoginRequest>({
      type,
      provider,
      data: request,
    });
  };
}
